<p-tabs *transloco="let transloco" [libTabsQuery]="this.props.query || 't'">
  <p-tablist>
    @for (tab of this.field.fieldGroup; track tab; let index = $index) {
      <p-tab [value]="index">
        <span
          class="-my-2 mr-2 flex items-center gap-2 whitespace-nowrap py-2 text-lg leading-4"
          [ngClass]="{ 'text-red-600': (errorCount$(tab) | async) || false }">
          {{ transloco(tab.props?.label || '') }}
        </span>
        @if (errorCount$(tab) | async) {
          <span class="-my-2 rounded bg-red-500 px-1 py-px text-white"
            >{{ (errorCount$(tab) | async) || '' }} {{ transloco('error') }}</span
          >
        }
      </p-tab>
    }
  </p-tablist>
  <p-tabpanels class="!px-0" style="background: unset">
    @for (tab of this.field.fieldGroup; track tab; let index = $index) {
      <p-tabpanel [value]="index">
        <formly-field [field]="tab"></formly-field>
      </p-tabpanel>
    }
  </p-tabpanels>
</p-tabs>
